module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage addrule_edit"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": true,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "关联账号",
      "prop": "userId"
    }
  }, [_c('el-select', {
    ref: "account",
    attrs: {
      "clearable": "",
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关联账号名称",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "visible-change": _vm.visibleChange,
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.params.userId),
      callback: function($$v) {
        _vm.$set(_vm.params, "userId", $$v)
      },
      expression: "params.userId"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.account,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推广二维码",
      "prop": "name"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.downloadImg(_vm.indata.id)
      }
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "点击下载二维码",
      "placement": "top-start"
    }
  }, [_c('vue-qr', {
    ref: 'Qrcode' + _vm.indata.id,
    attrs: {
      "text": _vm.urlQrcode(_vm.indata),
      "margin": 10,
      "size": 500,
      "width": 100
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("停用")])], 1), _vm._v("\n                停用后，将不在官网上展示，自定义链接不支持访问\n\n        ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-4e4af43b"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/user/lawyer_library/add/src/subpage1.vue
// module id = 1485
// module chunks = 1